import { eventsContract } from '@mntn/api-contracts/seller/v1/events'
import { QueryClient } from '@tanstack/react-query'
import { initClient } from '@ts-rest/core'

export const queryClient = new QueryClient()

export const createEventClient = ({
  baseUrl,
  getToken,
  getOrgHeaders,
}: {
  baseUrl: string
  getToken: () => Promise<string | null>
  getOrgHeaders: () => Promise<Record<string, string>> | Record<string, string>
}) =>
  initClient(eventsContract, {
    baseUrl: `${baseUrl.replace(/\/$/, '')}/api`,
    baseHeaders: {},
    jsonQuery: true,
    api: async args => {
      const token = await getToken()
      const orgHeaders = await getOrgHeaders()
      const response = await fetch(args.path, {
        method: args.method,
        headers: {
          ...args.headers,
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
          ...orgHeaders,
        },
        body: args.body,
        credentials: 'include',
        keepalive: true,
      })
      const body = await response.json().catch(() => undefined)
      return {
        status: response.status,
        body,
        headers: response.headers,
      }
    },
  })

export type SelectEventClient = ReturnType<typeof createEventClient>
